import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enJSON from './en.json'


i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: enJSON  // Assign the JSON to the translation key
        }
    }, // Where we're gonna put translations' files  
    lng: "en", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",
    interpolation: {
        escapeValue: false
    }
});